<template>
  <div class="gift-card-edit-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <el-page-header @back="goBack" content="编辑礼品卡"></el-page-header>
    </div>

    <div class="gift-card-container">
      <!-- 左侧表单 -->
      <div class="form-section">
<!--        <div class="form-description">-->
<!--          <p>在下方修改详细信息，对礼品卡进行设置。完成后，客户即可购买此礼品卡。</p>-->
<!--          <p>客户成功购买礼品卡后，系统会通过电子邮件将礼品卡以及唯一编号发送给客户。</p>-->
<!--          <div class="online-purchase">-->
<!--            <span>可在线购买</span>-->
<!--            <el-switch-->
<!--              v-model="editForm.online_purchase"-->
<!--              active-text="需支付手续费"-->
<!--            ></el-switch>-->
<!--          </div>-->
<!--        </div>-->

        <el-form size="small" :model="editForm" :rules="formRules" ref="form" label-position="top">
          <el-form-item label="礼品卡名称" prop="name" class="required-field">
            <el-input v-model="editForm.name" placeholder="礼品卡名称" maxlength="100"></el-input>
          </el-form-item>

          <el-form-item label="说明" prop="description">
            <el-input type="textarea" v-model="editForm.description" placeholder="说明" :rows="3"></el-input>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="价格" prop="price" class="required-field">
                <el-input
                  v-model="editForm.price"
                  placeholder="价格"
                  type="number"
                  step="0.01"
                  min="0"
                  @input="validatePrice"
                >
                  <template slot="prepend">$</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="价值" prop="value">
                <el-input
                  v-model="editForm.value"
                  placeholder="价值"
                  type="number"
                  step="0.01"
                  min="0"
                  @input="validateValue"
                >
                  <template slot="prepend">$</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="有效期" prop="expiration_days">
            <el-select v-model="editForm.expiration_days" placeholder="选择有效期" style="width: 100%">
              <el-option label="永不结束" :value="0"></el-option>
              <el-option label="购买后 6 个月" :value="180"></el-option>
              <el-option label="购买后 9 个月" :value="270"></el-option>
              <el-option label="购买后 12 个月" :value="365"></el-option>
              <el-option label="购买后 24 个月" :value="730"></el-option>
            </el-select>
          </el-form-item>

          <div class="form-notes">
            <p>礼品卡并非实名制，拥有卡号的任何人均可使用。</p>
            <p>礼品卡并非一次性使用，可以根据需要多次使用，直到余额用完为止。</p>
          </div>
        </el-form>
      </div>

      <!-- 右侧卡片预览 -->
      <div class="preview-section">
        <div class="gift-card-preview" :style="cardStyle">
          <div class="card-header">
            <span class="card-title">礼品卡</span>
            <span class="card-price">${{ editForm.price || '0.00' }}</span>
          </div>
          <div class="card-name">{{ editForm.name || '礼品卡名称' }}</div>
          <div class="card-scope">所有服务和产品</div>
          <div class="card-footer">
            <div class="card-logo">
              <div class="logo-circle"></div>
              <span>{{ baseInfo.supplier_name }}</span>
            </div>
            <div class="card-expiry">
              <span>有效期至</span>
              <span>{{ expiryText }}</span>
            </div>
          </div>
        </div>



                <!-- 卡片设计样式 -->
        <div class="design-section">
          <h4>卡片设计样式</h4>
          <div class="current-design">
            <div v-if="selectedCardDesign" class="selected-design">
              <img :src="selectedCardDesign.image_url" alt="已选择的卡片背景" class="selected-image" />
              <div class="design-info">
                <p>已选择背景图片</p>
                <el-button type="text" @click="openDesignSelector">更换背景</el-button>
              </div>
            </div>
            <div v-else class="no-design">
              <div class="placeholder-design">
                <i class="el-icon-picture"></i>
                <p>未选择背景图片</p>
              </div>
              <el-button type="primary" @click="openDesignSelector">选择背景</el-button>
            </div>
          </div>
        </div>

        <!-- 适用的服务 -->
        <div class="service-section">
          <h4>适用的服务</h4>
          <div class="service-item">所有服务和产品</div>
        </div>
      </div>
    </div>

    <!-- 操作按钮 -->
    <div class="page-footer">
      <el-button @click="goBack">返 回</el-button>
      <el-button type="primary" @click="editGiftCard" :loading="loading">保 存</el-button>
    </div>

    <!-- 卡片设计选择弹窗 -->
    <CardDesignSelector
      :visible.sync="designSelectorVisible"
      :current-card="selectedCardDesign"
      :form-data="editForm"
      @select="onCardDesignSelect"
    />
  </div>
</template>

<script>
import GiftCardApi from '@/api/gift_card/gift_card.js';
import CardDesignSelector from './CardDesignSelector.vue';

export default {
  components: {
    CardDesignSelector
  },
  inject: ['baseInfo'],
  data() {
    return {
      editForm: {
        id: '',
        name: '',
        description: '',
        price: '',
        value: '',
        expiration_days: 0,
                  card_image: 0,
          applicable_scope: 0,
          // online_purchase: true
      },
      formRules: {
        name: [
          {
            required: true,
            message: '请输入礼品卡名称',
            trigger: 'blur'
          }
        ],
        price: [
          {
            required: true,
            message: '请输入价格',
            trigger: 'blur'
          },
          {
            pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
            message: '请输入正确的价格格式',
            trigger: 'blur'
          }
        ],
        value: [
          {
            pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
            message: '请输入正确的价值格式',
            trigger: 'blur'
          }
        ]
      },
      loading: false,
      /*设计选择弹窗显示状态*/
      designSelectorVisible: false,
      /*选中的卡片设计*/
      selectedCardDesign: null
    };
  },

  computed: {
    cardStyle() {
      if (this.selectedCardDesign) {
        return {
          backgroundImage: `url(${this.selectedCardDesign.image_url})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
      }
      return { background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' };
    },
    expiryText() {
      if (this.editForm.expiration_days === 0) {
        return '永不结束';
      }
      const months = Math.round(this.editForm.expiration_days / 30);
      return `购买后 ${months} 个月`;
    }
  },
  created() {
    this.getGiftCardDetail();
  },
  methods: {
    /**
     * 获取礼品卡详情
     */
    getGiftCardDetail() {
      const id = this.$route.query.id;
      if (id) {
        GiftCardApi.detail({id: id}, true)
          .then(data => {
            console.log('获取到的礼品卡详情:', data); // 调试信息
            const detail = data.data.detail; // 修改数据路径
            this.editForm = {
              id: detail.id,
              name: detail.name || '',
              description: detail.description || '',
              price: detail.price || '',
              value: detail.value || '',
              expiration_days: detail.expiration_days || 0,
              card_image: detail.card_image || '',
              applicable_scope: detail.applicable_scope || 0,
              // online_purchase: true
            };
            
            // 如果有卡片背景，则获取对应的图片信息用于显示
            if (detail.card_image) {
              this.loadCardImageById(detail.card_image);
            }
          })
          .catch(error => {
            this.$message.error('获取礼品卡详情失败');
            console.error('获取详情错误:', error);
            this.goBack();
          });
      } else {
        this.$message.error('缺少礼品卡ID参数');
        this.goBack();
      }
    },

    /**
     * 根据图片路径加载卡片图片信息
     */
    loadCardImageById(imagePath) {
      console.log('正在加载卡片背景，路径:', imagePath); // 调试信息
      GiftCardApi.getCardImageList({}, true)
        .then(data => {
          console.log('获取到的卡片背景列表:', data); // 调试信息
          const cardList = data.data.list || [];
          const matchedCard = cardList.find(card => card.image_path === imagePath);
          console.log('匹配到的卡片:', matchedCard); // 调试信息
          if (matchedCard) {
            this.selectedCardDesign = matchedCard;
            console.log('设置选中的卡片设计:', this.selectedCardDesign); // 调试信息
          } else {
            console.warn('未找到匹配的卡片背景:', imagePath);
          }
        })
        .catch(error => {
          console.error('获取卡片背景失败:', error);
        });
    },

    /**
     * 打开设计选择器
     */
    openDesignSelector() {
      this.designSelectorVisible = true;
    },

    /**
     * 选择卡片设计
     */
    onCardDesignSelect(cardDesign) {
      this.selectedCardDesign = cardDesign;
      this.editForm.card_image = cardDesign.image_path; // 保存 image_path 到数据库
    },

    /**
     * 编辑礼品卡
     */
    editGiftCard() {
      let self = this;
      let params = { ...self.editForm };
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          GiftCardApi.edit(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '修改成功',
                type: 'success'
              });
              // 返回列表页面
              self.$router.push('/gift_card/gift_card/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /**
     * 验证价格格式
     */
    validatePrice(value) {
      // 保留两位小数
      if (value && value.toString().includes('.')) {
        const parts = value.toString().split('.');
        if (parts[1] && parts[1].length > 2) {
          this.editForm.price = parseFloat(value).toFixed(2);
        }
      }
    },

    /**
     * 验证价值格式
     */
    validateValue(value) {
      // 保留两位小数
      if (value && value.toString().includes('.')) {
        const parts = value.toString().split('.');
        if (parts[1] && parts[1].length > 2) {
          this.editForm.value = parseFloat(value).toFixed(2);
        }
      }
    },

    /**
     * 返回列表页面
     */
    goBack() {
      this.$router.push('/gift_card/gift_card/index');
    }
  }
};
</script>

<style scoped>
.gift-card-edit-page {
  padding: 20px;
  background: #fff;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.gift-card-container {
  display: flex;
  gap: 40px;
  min-height: 600px;
}

.form-section {
  flex: 1;
  padding-right: 20px;
}

.form-description {
  margin-bottom: 30px;
  color: #666;
  line-height: 1.6;
}

.online-purchase {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.required-field .el-form-item__label::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

.form-notes {
  margin-top: 30px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.preview-section {
  flex: 1;
  padding-left: 20px;
  border-left: 1px solid #eee;
}

.gift-card-preview {
  width: 100%;
  height: 200px;
  border-radius: 12px;
  padding: 20px;
  color: white;
  position: relative;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-title {
  font-size: 16px;
  font-weight: 500;
}

.card-price {
  font-size: 24px;
  font-weight: bold;
}

.card-name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

.card-scope {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 30px;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
}

.card-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
}

.card-expiry {
  text-align: right;
  font-size: 12px;
}

.design-section,
.service-section {
  margin-bottom: 30px;
}

.design-section h4,
.service-section h4 {
  margin-bottom: 15px;
  color: #333;
  font-size: 16px;
}

.current-design {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
}

.selected-design {
  display: flex;
  align-items: center;
  gap: 15px;
}

.selected-image {
  width: 80px;
  height: 50px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.design-info {
  flex: 1;
  text-align: left;
}

.design-info p {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 14px;
}

.no-design {
  padding: 20px;
}

.placeholder-design {
  margin-bottom: 15px;
}

.placeholder-design i {
  font-size: 48px;
  color: #ddd;
  display: block;
  margin-bottom: 10px;
}

.placeholder-design p {
  color: #999;
  margin: 0;
}

.service-item {
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  color: #666;
}

.page-footer {
  text-align: center;
  margin-top: 40px;
  padding: 20px;
  border-top: 1px solid #eee;
}

.page-footer .el-button {
  margin: 0 10px;
  min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/gift_card/gift_card/edit.vue